import {
  geckoPerms,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  RolodexUserMetadata,
} from 'types'

export const computePermissions = (
  userMetadata: RolodexUserMetadata
): {
  permissions: Set<string>
} => {
  const permissions = userMetadata.roles.map((role) => role.name)
  const maskedPermissions = new Set(permissions)
  if (!permissions.includes(PERMISSION_GECKO_INTERNAL_MEMBER)) {
    geckoPerms.forEach((p) => maskedPermissions.delete(p))
  }
  return { permissions: maskedPermissions }
}
